export default {
    namespaced: true,
    account_settings: {
      title: "configurações de conta",
      mobile_app: {
        title: "aplicativo móvel",
        description: "Você pode vincular seu aplicativo móvel à sua conta digitalizando o código QR",
        timeout_with_minutes: "Válido por {minutes} minutos e {seconds} segundos",
        timeout_without_minutes: "Válido por {seconds} segundos",
      },
      appColors: {
        title: "Cores do aplicativo",
        description: "Aqui você pode alterar o tema do aplicativo",
        updating: "Atualização de cores",
        success: "Cores alteradas com sucesso, recarregamento da página...",
        main_dashboard: "Painel principal",
        components: "Componentes",
        images: "Imagens",
        success_delete: "Tema excluído com sucesso",
        confirm_delete: "Tem certeza de que excluirá o '%theme%'  do tema?",
        success_edit: "Tema atualizado com sucesso",
        success_create: "Tema criado com sucesso",
        theme_builder_description: "selecionar ou personalizar o tema da IU"
      }
    },
};
  